import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AlertMessageComponent } from '../../alert-message/alert-message.component';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';

@Component({
  selector: 'app-revoke-api-modal',
  imports: [TranslateModule, AlertMessageComponent, ModalBaseComponent],
  templateUrl: './revoke-api-modal.component.html',
})
export class RevokeApiModalComponent {
  protected dialogRef = inject(DialogRef);
  protected data = inject(DIALOG_DATA);
}
